<ng-container *ngIf="isHome; else swipe">
  <div class="newPax__cont newPax__cont--main">
    <app-ds-data-action-card
      [failedType]="dataActionFailedType.Warning"
      [info]="[
        {
          Type: dataActionCardInfoType.Action,
          Title: newPaxlabel | capitalize,
          DataIcon: typeIcon,
          ActionIcon: selectionIcon,
          ActionIsFailed: isError
        }
      ]"
      (clickEvent)="emit()">
    </app-ds-data-action-card>
  </div>
</ng-container>

<ng-template #swipe>
  <div class="newPax__cont newPax__cont--swipe">
    <app-ds-data-action-card
      [info]="[
        {
          Type: dataActionCardInfoType.Action,
          Title: label,
          DataIcon: icon,
          ActionIcon: icons.Add
        }
      ]"
      (clickEvent)="swipeClick.emit()">
    </app-ds-data-action-card>
  </div>
</ng-template>
  
